import { defineComponent, openBlock, createElementBlock, createElementVNode, createTextVNode, createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "atc-modal__product-details",
  "aria-label": "Product details - item not added to cart"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = ["href"];
const _hoisted_5 = {
  key: 2
};
const _hoisted_6 = {
  key: 3
};
const _hoisted_7 = {
  key: 4
};
const _hoisted_8 = {
  key: 5
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AddToCartErrorModal",
  props: {
    scenario: {
      default: ""
    },
    loginLink: {
      default: ""
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("section", _hoisted_1, [_ctx.scenario == "limit" ? (openBlock(), createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [createElementVNode("p", {
        class: "error-msg cart-limit"
      }, [createTextVNode(" Please checkout and start a new order or call us at "), createElementVNode("a", {
        href: "tel:+1-800-426-4840"
      }, "1-800-426-4840"), createTextVNode(" to complete a transaction of more than 50 items ")], -1)]))) : _ctx.scenario == "token" ? (openBlock(), createElementBlock("div", _hoisted_3, [_cache[1] || (_cache[1] = createElementVNode("p", {
        class: "error-msg token-error"
      }, " We're unable to display this view of your cart right now. ", -1)), _cache[2] || (_cache[2] = createElementVNode("p", null, "This is likely because you are no longer logged in. ", -1)), _ctx.loginLink ? (openBlock(), createElementBlock("a", {
        key: 0,
        href: _ctx.loginLink
      }, "Please click here to log in.", 8, _hoisted_4)) : createCommentVNode("", true)])) : _ctx.scenario == "backorder" ? (openBlock(), createElementBlock("div", _hoisted_5, _cache[3] || (_cache[3] = [createElementVNode("p", {
        class: "error-msg backorder-error"
      }, [createTextVNode(" We are unable to add this item to your cart. You may try entering a lower quantity or call us at "), createElementVNode("a", {
        href: "tel:+1-800-426-4840"
      }, "1-800-426-4840"), createTextVNode(" for help completing your order. ")], -1)]))) : _ctx.scenario === "membership" ? (openBlock(), createElementBlock("div", _hoisted_6, _cache[4] || (_cache[4] = [createElementVNode("p", {
        class: "error-msg multiple-memberships"
      }, [createTextVNode(" You may only purchase one membership for yourself online. To purchase a gift membership, please call "), createElementVNode("a", {
        href: "tel:+1-800-426-4840"
      }, "1-800-426-4840"), createTextVNode(" or visit your local REI store. ")], -1)]))) : _ctx.scenario === "backorder-zero" ? (openBlock(), createElementBlock("div", _hoisted_7, _cache[5] || (_cache[5] = [createElementVNode("p", {
        class: "error-msg backorder-zero-error"
      }, " Your selection is no longer available. For some products, other sizes and colors may be available. ", -1)]))) : (openBlock(), createElementBlock("div", _hoisted_8, _cache[6] || (_cache[6] = [createElementVNode("p", {
        class: "error-msg general-error"
      }, [createTextVNode(" Due to a technical issue, we were unable to add this item to your cart. Please refresh the page and try again or call us at "), createElementVNode("a", {
        href: "tel:+1-800-426-4840"
      }, "1-800-426-4840"), createTextVNode(" to complete your order. ")], -1)])))]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=AddToCartErrorModal.mjs.map
